// import React from "react";
import "./HealthOnePricingPlans.scss";

const HealthOnePricingPlans = () => {
  return (
    <div className="health-one-pricing-container">
      <div className="health-one-pricing-info">
        <h5>Pricing Plans</h5>
        <h2 className="health-one-common-white-parent-heading">
          Explore Our Pricing Plan Solutions
        </h2>
        <p>
          Discover pricing options designed to accommodate practices of all
          sizes.
        </p>
        <div className="toggle-switch">
          <span>Annually</span>
          <label className="switch">
            <input type="checkbox" checked readOnly />
            <span className="slider"></span>
          </label>
          <span>Monthly</span>
        </div>
      </div>
      <div className="pricing-cards">
        <div className="card standard">
          <h4>Standard plan</h4>
          <p className="sub">Best for small healthcare practices</p>
          <h2>
            $29 <span>/Month</span>
          </h2>
          <ul>
            <li>Patient Data Management</li>
            <li>Appointment Scheduling</li>
            <li>Data Security & HIPAA Compliance</li>
            <li>Basic Billing and Claims Processing</li>
          </ul>
          <button>Try for free →</button>
        </div>
        <div className="card enterprise">
          <h4>Enterprise plan</h4>
          <p className="sub">Best for large practices or hospitals</p>
          <h2>
            $199 <span>/Month</span>
          </h2>
          <ul>
            <li>All features from the Standard Plan</li>
            <li>Enhanced Data Visualization Tools</li>
            <li>Tailored Solutions for Specific Needs</li>
            <li>Custom Workflow Automation</li>
          </ul>
          <button>Try for free →</button>
        </div>
      </div>
    </div>
  );
};

export default HealthOnePricingPlans;
